"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var WickedApiClient_1 = require("../api/WickedApiClient");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var bannerZoneServices = /** @class */ (function () {
    function bannerZoneServices(banersClient) {
        this.banersClient = banersClient;
        this._userBaners = [];
        this._userBanersIsReady = new rxjs_1.ReplaySubject(1);
        this.userBanerIsChecked = false;
    }
    Object.defineProperty(bannerZoneServices.prototype, "userBaners", {
        get: function () {
            return this._userBaners;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(bannerZoneServices.prototype, "userBanersIsReady$", {
        get: function () {
            return this._userBanersIsReady.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    bannerZoneServices.prototype.addUserBaner = function (baner) {
        this._userBaners.push(baner);
    };
    bannerZoneServices.prototype.removeUsedBanerFromList = function (banerIndex) {
        this._userBaners.splice(banerIndex, 1);
    };
    //user baners compability
    bannerZoneServices.prototype.getAllUserBaners = function (isMobile) {
        var _this = this;
        if (isMobile === void 0) { isMobile = 0; }
        return new Promise(function (resolve, reject) {
            _this.banersClient.getAllUserBaners(isMobile).subscribe(function (response) {
                _this._userBaners = response;
                _this._userBanersIsReady.next(true);
                resolve(response);
            });
        });
    };
    bannerZoneServices.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function bannerZoneServices_Factory() { return new bannerZoneServices(i0.ɵɵinject(i1.BannersClient)); }, token: bannerZoneServices, providedIn: "root" });
    return bannerZoneServices;
}());
exports.bannerZoneServices = bannerZoneServices;
var advType;
(function (advType) {
    advType[advType["HORIZONTAL"] = 0] = "HORIZONTAL";
    advType[advType["VERTICAL"] = 1] = "VERTICAL";
})(advType = exports.advType || (exports.advType = {}));
